// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"837651ba","589":"efd10190"}[chunkId] + ".css";
};